<template>
  <form novalidate @submit.prevent="onSubmit">
    <LsModal title="Turn Down Quote" track-id="turn_down_quote_modal_reject">
      <template #body>
        <div class="columns">
          <div class="column">
            <LsInfoCard
              class="turn-down-quote-modal-reject--ask-question"
              style="display: relative;"
            >
              <BLoading :active.sync="conversation.loadingStatus.isLoading" :is-full-page="false" />
              <p>
                Do you have any questions about the price, proposed service date or details of the
                proposed work? If you would like to see an update to this quote you can
                <LsClickable
                  test-id="ask_a_question"
                  track-id="turn_down_quote_modal_reject-ask_question_clickable"
                  class="turn-down-quote-modal-reject--ask-question-clickable"
                  @click="askAQuestion"
                >
                  {{ askQuestionText }}.
                </LsClickable>
              </p>
            </LsInfoCard>
            <LsInput
              v-model="details"
              track-id="turn_down_quote_modal_reject-details"
              type="textarea"
              test-id="details"
              name="details"
              label="Please provide additional details to help us provide better quotes:"
            />
          </div>
        </div>
      </template>
      <template #footer>
        <LsButton
          text="turn down"
          track-id="turn_down_quote_modal_reject-turn_down"
          type="submit"
          :loading="isUpdating"
        />
      </template>
    </LsModal>
  </form>
</template>

<script>
import { LsModal, LsInfoCard, LsButton, LsInput, LsClickable } from '@/components/common';
import VueTypes from 'vue-types';
import { mapState, mapActions } from 'vuex';
import {
  SCHEDULES__REJECT_QUOTE,
  RECOMMENDATIONS__REJECT_QUOTE,
  REQUIRED_SERVICES__REJECT_QUOTE,
  CONVERSATION__START_CONVERSATION,
} from '@/store/types';

export default {
  name: 'TurnDownQuoteModalReject',
  components: { LsModal, LsInfoCard, LsButton, LsInput, LsClickable },
  props: {
    name: VueTypes.string.isRequired,
    contractorUserId: VueTypes.number.isRequired,
    //eslint-disable-next-line vue/prop-name-casing
    property_id: VueTypes.number.isRequired,
    //eslint-disable-next-line vue/prop-name-casing
    schedule_id: VueTypes.number,
    //eslint-disable-next-line vue/prop-name-casing
    recommendation_id: VueTypes.number,
    //eslint-disable-next-line vue/prop-name-casing
    requiredService_id: VueTypes.number,
  },
  data() {
    return {
      details: '',
    };
  },
  computed: {
    ...mapState(['schedules', 'recommendations', 'requiredServices', 'conversation']),
    askQuestionText() {
      return `Ask ${this.name} a Question`;
    },
    isUpdating() {
      return (
        this.schedules.loadingStatus.isUpdating ||
        this.recommendations.loadingStatus.isUpdating ||
        this.requiredServices.loadingStatus.isUpdating
      );
    },
  },
  methods: {
    ...mapActions([
      SCHEDULES__REJECT_QUOTE,
      RECOMMENDATIONS__REJECT_QUOTE,
      REQUIRED_SERVICES__REJECT_QUOTE,
      CONVERSATION__START_CONVERSATION,
    ]),
    async askAQuestion() {
      await this[CONVERSATION__START_CONVERSATION]({
        contractorUserId: this.contractorUserId,
      });
      this.$router.push({
        name: 'inboxConversation',
        params: {
          conversation_id: this.conversation.currentConversation.conversation_id,
        },
      });
      this.$parent.$parent.close();
    },
    onSubmit() {
      if (this.schedule_id) {
        this[SCHEDULES__REJECT_QUOTE]({
          schedule_id: this.schedule_id,
          details: this.details,
          onSuccess: this.onSuccess,
        });
      } else if (this.recommendation_id) {
        this[RECOMMENDATIONS__REJECT_QUOTE]({
          recommendation_id: this.recommendation_id,
          property_id: this.property_id,
          details: this.details,
          onSuccess: this.onSuccess,
        });
      } else {
        this[REQUIRED_SERVICES__REJECT_QUOTE]({
          requiredService_id: this.requiredService_id,
          property_id: this.property_id,
          details: this.details,
          onSuccess: this.onSuccess,
        });
      }
    },
    onSuccess() {
      this.$parent.$parent.close();
      this.$router.push({
        name: 'services',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.turn-down-quote-modal-reject--ask-question {
  margin-bottom: 30px;
}

.turn-down-quote-modal-reject--ask-question-clickable {
  color: $blue;
}

.themed-app {
  .turn-down-quote-modal-reject--ask-question-clickable {
    color: $theme-color-blue;
  }
}
</style>
